import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { isAdmin } from '../utility/isAdmin';

interface PrivateRouteProps {
    requireRole?: 'redu-admin';
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ requireRole }) => {
    const { isAuthenticated, userInfo } = useSelector((state: RootState) => state.auth);

    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    if (requireRole === 'redu-admin' && !isAdmin(userInfo)) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default PrivateRoute;
